//@ts-nocheck
import * as React from 'react';
import { aggUniversityAlternateName, getStateAbbr } from '../../Common/Helpers';
import { exportFactSheetChart } from './FactSheetButtonHelpers';

class StateLegislativeMaps extends React.Component<Props, {}> {

    renderMap(imgSrc) {
        if (imgSrc) {
            return <div style={{ height: '500px', width: '100%', overflow: 'hidden' }}>
                <img src={imgSrc} style={{ margin: '0 auto', objectFit: "contain", maxWidth: '100%', maxHeight: '100%', display: 'block' }}></img>
            </div>
        } else {
            return <div className="loading">loading <i className="fa fa-spinner"></i></div>;
        }
    }

    renderMapSection(mapSrc, fiscalYearLabel, mapIndex) {
        const { university, title_text, state, mapFilePrefix } = this.props;
        const fileName = `${mapFilePrefix}-map-fy-${fiscalYearLabel}.png`;

        return (
            <div className="row statelegislativemap-row">
                <div className="col-md-12">
                    <div className="statelegislativemap_div">
                        <a
                            className="factsheet-map-export"
                            onClick={() => exportFactSheetChart("statelegislativemap_div", mapIndex, fileName)}
                        >
                            <i className="fa fas fa-download ecr_export"></i>EXPORT CHART
                        </a>
                        <h3>
                            {aggUniversityAlternateName(university)}<br />
                            Research-Related Spending (Federal and Non-Federal),<br />
                            by {title_text} ({getStateAbbr(state)}), FY {fiscalYearLabel}
                        </h3>
                        {this.renderMap(mapSrc)}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { start_year, current_year, latest_map, range_map, mapIndexOffset } = this.props;

        return (
            <div>
                {this.renderMapSection(latest_map, `${current_year}`, mapIndexOffset)}
                {this.renderMapSection(range_map, `${start_year}-${current_year}`, mapIndexOffset + 1)}
            </div>
        );
    }
}

export default StateLegislativeMaps;
